const common = {
    no_data: '暂无数据',
    header: {
        business_name: '您的企业'
    },
    download_app: {
        text: '要使用Simply网页版，请使用笔记本电脑或台式机。',
        button: '下载手机版'
    },
    unknown: '未知',
    request_error: '发生错误。请重试！如问题持续，请联系客服。',
    home: '首页',
    dashboard: '仪表盘',
    product: '产品',
    add_product: '添加产品',
    edit_product: '编辑产品',
    stock_in: '入库',
    Sales_Turnover: '销售额',
    profit: '利润',
    stock_out: '出库',
    staff: '员工',
    stock_audit: '库存审计',
    button: {
        save: '保存',
        save_and_add_more: '保存并添加更多',
        submit: '提交',
        done: '完成',
        edit: '编辑',
        save_edit: '保存更改',
        yes: '是',
        clear: '清除',
        delete: '删除',
        cancel: '取消',
        reset: '重置'
    },
    select_date: '选择日期',
    select_action: '选择操作',
    mandatory: ' *(必填)',
    not_mandatory: '(选填)',
    business: '企业',
    account: '账户',
    profile: '个人资料',
    setting: '设置',
    whichLanguage: '简体中文',
    headerDashboard: '成为VIP',
    contact_us: '联系我们',
    logout: '退出登录',
    category: '分类',
    add_category: '添加类别',
    data: '数据',
    history: '历史记录',
    lowStockAlert: '库存不足提醒',
    Expenses: '支出',
    lowStockAlertButton: '添加安全库存数量',
    message: {
        login_success: '登录成功！',
        onboard_success: '恭喜！您的旅程已经开始！',
        successfully_saved: '数据保存成功',
        successfully_deleted: '数据删除成功',
        error_required_field: '必填字段不能为空',
        no_access: '无访问权限',
        no_permission: "您没有权限",
        error_update_history: '更新历史记录失败'
    },
    no_permission_dialog: {
        title: '无权限',
        description: '您没有查看支出的权限。请联系您的管理员。'
    },
    feedback: '提供反馈',
    contact: '联系方式',
    add: '添加',
    supplier: '供应商',
    customer: '客户',
    random: '随机',
    scan: '扫描',
    enter: '通过扫描条码登录',
    terms: {
        text: '继续即表示您同意',
        link: '隐私政策'
    },
    others: '其他',
    calender: {
        presets: {
            today: '今天',
            yesterday: '昨天',
            last_7_days: '过去7天',
            last_30_days: '过去30天',
            this_month: '本月',
            last_month: '上个月',
            custom_range: '自定义范围'
        }
    },
    print_large: '大号打印 (A4)',
    print_letter: '信纸打印 (US)',
    print_dot_matrix: '大号打印 (点阵)',
    print_medium: '中号打印 (75mm)',
    print_small: '小号打印 (48mm)',
    format: '纸张格式',
    preview: '预览',
    view_invoice: '发票',
    view_chalan: '送货单',
    price: '价格',
    stock: '库存',
    quantity: '数量',
    total: '总计',
    print_footer_left: '创建者',
    print_footer_center: '打印于',
    print_footer_date: '日期',
    print_to: '至',
    language: '简体中文',
    dateStatus: '过去7天',
    placeholder: '交易类型',
    staffHistory: '选择员工',
    languageTitle: '简体中文',
    date: '日期',
    download: '下载',
    download_excel: '下载Excel',
    download_pdf: '下载条形码',
    currentTitle: '货币',
    Selectperiod: '选择周期',
    TransactionType: '交易类型',
    SelectCustomer: '选择客户',
    invoice: '发票',
    login: {
        google: '使用Google登录',
        apple: '使用Apple登录'
    },
    trusted_by: {
        title: '受到印度尼西亚 🇮🇩 超过50,000家企业的信赖'
    },
    privacyPolicyOne: "登录即表示您同意Simply的",
    privacyPolicyTwo: '隐私政策',
    manufacture: '制造商',
    warehouse: '仓库',
    error: {
        title: '哎呀！出了点问题',
        description: '发生了一个意外错误。请尝试刷新页面或返回首页。',
        refresh: '刷新页面',
        go_back: '返回首页',
        not_found: '页面未找到'
    },
    totalPurchasePrice: '总采购价格',
    pageTotalPurchaseAmount: '本页总采购金额',
    approval_status: '审批状态',
    pending: '待处理',
    approved: '已批准',
    rejected: '已拒绝',
    select_fields: '选择字段',
    syncWithTally: '与 Tally 同步',
    importFromTally: '从 Tally 导入',
    exportToTally: '导出到 Tally',
    All: '全部',
    Approval: '审批'
}

export default common;
